export const DEFAULT_CARD_COVER_IMAGE_SIZE = {
  width: 640,
  height: 360,
};

export const COMPACT_CARD_COVER_IMAGE_SIZE = {
  width: 792,
  height: 594,
};
